export function isValidCPF(cpf: string): boolean {
	if (!cpf) return false;

	// Remove caracteres não numéricos
	cpf = cpf.replace(/\D/g, "");

	if (cpf.length !== 11) return false;

	// Sequências repetidas são inválidas
	if (/^(\d)\1{10}$/.test(cpf)) return false;

	let sum = 0;
	let remainder;

	for (let i = 1; i <= 9; i++) {
		sum += Number.parseInt(cpf.substring(i - 1, i)) * (11 - i);
	}
	remainder = (sum * 10) % 11;
	if (remainder === 10 || remainder === 11) remainder = 0;
	if (remainder !== Number.parseInt(cpf.substring(9, 10))) return false;

	sum = 0;
	for (let i = 1; i <= 10; i++) {
		sum += Number.parseInt(cpf.substring(i - 1, i)) * (12 - i);
	}
	remainder = (sum * 10) % 11;
	if (remainder === 10 || remainder === 11) remainder = 0;
	if (remainder !== Number.parseInt(cpf.substring(10, 11))) return false;

	return true;
}
